var $029f69a62debeaff$exports = {};
$029f69a62debeaff$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `F\xe4rgv\xe4ljaren`,
    "colorSwatch": `f\xe4rgruta`,
    "transparent": `genomskinlig`,
    "twoDimensionalSlider": `2D-reglage`
};


export {$029f69a62debeaff$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
